export default __webpack_public_path__ + "static/menu-bg-c627d19c7c937269b3eabcddaa0e7388.png";